import { render, staticRenderFns } from "./SelectBoxInput.vue?vue&type=template&id=3a3504be&scoped=true"
import script from "./SelectBoxInput.vue?vue&type=script&lang=js"
export * from "./SelectBoxInput.vue?vue&type=script&lang=js"
import style0 from "./SelectBoxInput.vue?vue&type=style&index=0&id=3a3504be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3504be",
  null
  
)

export default component.exports